module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/bikla-d4dc7a1ef084778106ba3d9d4087c04a.png";